// Phase field names used for tier validation
export const PHASE_FIELDS = [
  'internalBetaPhaseInfo',
  'privateBetaPhaseInfo',
  'publicBetaPhaseInfo',
  'gaPhaseInfo'
] as const;

export const INTERNAL_BETA_PHASE = 'internalBetaPhaseInfo';

// Phases without Internal Beta (Private Beta, Public Beta, GA)
export const PHASES_WITHOUT_INTERNAL_BETA = PHASE_FIELDS.filter(
  phase => phase !== INTERNAL_BETA_PHASE
) as readonly string[];
